/* eslint-disable import/order */
import React from 'react';

import { addModal, addStylesToSchema } from '@/exceed';
import i18n from 'i18next';

import getExistingAudienceSchema from '../schemas/getExistingAudienceSchema';
import getNewAudienceSchema from '../schemas/getNewAudienceSchema';

import NewAudienceFormContainer from '../containers/newAudienceFormContainer';

import styles from '../styles/audienceSelectionModal.module.scss';

export default (audiences) => {
  const schema = audiences
    ? addStylesToSchema(getExistingAudienceSchema(audiences), styles)
    : addStylesToSchema(getNewAudienceSchema(), styles);

  const id = 'audience';

  return addModal({
    actions: audiences && [
      {
        action: 'save',
        color: 'brand',
        element: 'button',
        getIsDisabled: ({ hasFormError }) => hasFormError,
        text: i18n.t('select-audience'),
      },
      {
        action: 'cancel',
        element: 'button',
        text: i18n.t('cancel'),
        variant: 'ghost',
      },
    ],
    className: styles.element,
    component: !audiences ? <NewAudienceFormContainer id={id} schema={schema} /> : null,
    hasCloseButton: true,
    id,
    isFullScreen: true,
    schema: audiences && schema,
    title: i18n.t(audiences ? 'select-existing-audience' : 'create-new-audience'),
  });
};
